/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Controls visual size and animation on the journey map. STANDARD = small circle, MILESTONE = diamond, CHAMPION = star.
 * @export
 */
export const SeasonNodeType = {
    STANDARD: 'STANDARD',
    MILESTONE: 'MILESTONE',
    CHAMPION: 'CHAMPION'
} as const;
export type SeasonNodeType = typeof SeasonNodeType[keyof typeof SeasonNodeType];


export function instanceOfSeasonNodeType(value: any): boolean {
    for (const key in SeasonNodeType) {
        if (Object.prototype.hasOwnProperty.call(SeasonNodeType, key)) {
            if (SeasonNodeType[key as keyof typeof SeasonNodeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SeasonNodeTypeFromJSON(json: any): SeasonNodeType {
    return SeasonNodeTypeFromJSONTyped(json, false);
}

export function SeasonNodeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeasonNodeType {
    return json as SeasonNodeType;
}

export function SeasonNodeTypeToJSON(value?: SeasonNodeType | null): any {
    return value as any;
}

export function SeasonNodeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SeasonNodeType {
    return value as SeasonNodeType;
}

